import { Component, Inject } from '@angular/core';
import { JobPreferencesApiService } from '../job-preferences-api-service';
import { JobPreferencesService } from '../service/job-preferences.service';
import { ApiService } from '../../api.service';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentToken } from '../../../util';
import { Environment } from '../../../typings';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-job-preferences-read-only',
    templateUrl: './job-preferences-read-only.component.html',
    styleUrls: ['./job-preferences-read-only.component.scss'],
    standalone: false
})
export class JobPreferencesReadOnlyComponent {
  personId: number;
  isApplication: boolean;
  isRegistration: boolean;
  countryId: number;
  showEeocForm: boolean;
  token: string;

  WORK_TYPE = 'Work Type';
  HOURS = 'Hours';
  WORK_LOCATION = 'Work Location';
  dataLoaded: Promise<boolean>;

  constructor(
    private jobPreferencesApi: JobPreferencesApiService,
    public jobPreferencesService: JobPreferencesService,
    public apiService: ApiService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(EnvironmentToken) private environment: Environment
  ) {
    this.isApplication = this.route.snapshot.queryParamMap.get('isApplication') === 'true';
    this.isRegistration = this.route.snapshot.queryParamMap.get('isRegistration') === 'true';
    this.countryId = parseInt(this.route.snapshot.queryParamMap.get('talentCountryId'));
    this.showEeocForm = this.route.snapshot.queryParamMap.get('showEeocForm') === 'true';
    this.token = this.route.snapshot.queryParamMap.get('token');

    this.jobPreferencesService.isApplication = this.isApplication;
    this.jobPreferencesService.isRegistration = this.isRegistration;
    this.jobPreferencesService.countryId = this.countryId;
    this.jobPreferencesService.showEeocForm = this.showEeocForm;

    this.apiService.getUserInfo(false).subscribe(person => {
      this.personId = person.id;
      jobPreferencesApi.getCurrentJobPrefsData(person.id).subscribe(
        data => {
          jobPreferencesService.jobPreferencesData = data;
          if (this.jobPreferencesService.isJobPreferencesDataBlank()) {
            void this.router.navigate(['job-preferences-form'], {
              queryParams: {
                token: this.token,
                isApplication: this.isApplication,
                isRegistration: this.isRegistration,
                talentCountryId: this.countryId,
                showEeocForm: this.showEeocForm
              }
            });
          }
          jobPreferencesService.jobPreferencesData.jobPreferences.talentId = person.id;
        },
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        error => console.log('Failed to load job preferences data for personId: ' + this.personId + '. Error: ' + error),
        () => {
          this.dataLoaded = Promise.resolve(true);
        }
      );
    });
  }

  formatAmount(amount: number) {
    return amount === null ? '-' : amount;
  }

  formatSelections(selectionType) {
    const selectionOptions = [];
    switch (selectionType) {
      case this.WORK_TYPE:
        if (this.jobPreferencesService.jobPreferencesData.opportunity.permanentSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.employment-type.perm'));
        }
        if (this.jobPreferencesService.jobPreferencesData.opportunity.contractSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.employment-type.temp'));
        }
        if (this.jobPreferencesService.jobPreferencesData.opportunity.contractToHireSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.employment-type.temp-to-perm'));
        }
        break;
      case this.HOURS: {
        if (this.jobPreferencesService.jobPreferencesData.opportunity.partTimeSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.hours.part-time'));
        }
        if (this.jobPreferencesService.jobPreferencesData.opportunity.fullTimeSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.hours.full-time'));
        }
        break;
      }
      case this.WORK_LOCATION: {
        if (this.jobPreferencesService.jobPreferencesData.opportunity.onSiteSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.workplace.on-site'));
        }
        if (this.jobPreferencesService.jobPreferencesData.opportunity.offSiteSelected) {
          selectionOptions.push(this.translateService.instant('data-refresh.workplace.remote'));
        }
        break;
      }
    }
    return selectionOptions.length === 0 ? '-' : selectionOptions.join('; ');
  }

  looksGoodButtonClicked() {
    this.jobPreferencesApi.submitMoats(this.jobPreferencesService.jobPreferencesData).subscribe(
      () => {
        let path = 'myaquent/registration/';
        if (this.isApplication && this.showEeocForm) {
          path += `eeoc-page?talentCountryId=${this.countryId}&isApplication=${String(this.isApplication)}&isRegistration=${String(
            this.isRegistration
          )}`;
        } else {
          path += `talent/registration/success?isApplication=${String(this.isApplication)}&isRegistration=${String(this.isRegistration)}`;
        }
        top.location.replace(`${this.environment.matHost}/${path}`);
      },
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      error => console.log(';Failed to submit looks good for MOATS for personId: ' + this.personId + '. Error: ' + error)
    );
  }

  editButtonClicked() {
    void this.router.navigate(['job-preferences-form']);
  }
}
